import { useState } from 'react';

import { SLoginStatusProps } from '../ems-core/specific/SLoginStatus';
import { AxiosInstance } from 'axios';
import { ViewRecoveryPassword } from '../ems-core/views/RecoveryPassword';
import { recoverPassword, requestNewPin } from '../ems-core/scripts/api/auth';
import { Global } from '../ems-core/css/Global.styles';
import { useNavigate } from 'react-router-dom';
import { checkPasswordValid } from '../ems-core/scripts/common/user';

type Feedback = SLoginStatusProps['status'] | undefined;
type Props = {
  /**
   * Axios api instance
   */
  api: AxiosInstance;
  /**
   * Email get by the url params.
   */
  email: string;
  /**
   * Recovery token, if invalid, it's impossible to recover.
   */
  token: string;
};

/**
 * Recover password
 */
const Page = ({ api, email, token }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<Feedback>(undefined);

  return (
    <>
      <Global />
      <ViewRecoveryPassword
        status={status}
        email={email}
        onRecovery2FA={() => {
          setStatus('operation');

          requestNewPin(api, email)
            .then(() => {
              setStatus('pinCheckMail');
            })
            .catch(() => setStatus('pinCheckMailError'));
        }}
        onRecoveryPassword={(password, repeatPassword, pin) => {
          setStatus('operation');

          if (password.length === 0 || pin.length === 0) {
            setStatus('empty');
            return;
          }

          if (password !== repeatPassword) {
            setStatus('noMatch');
            return;
          }

          if (checkPasswordValid(password, repeatPassword) != undefined) {
            setStatus('passSecurity');
            return;
          }

          recoverPassword(api, email, password, pin, token)
            .then(() => {
              setStatus('recovered');
              setTimeout(() => navigate('/'), 3000);
            })
            .catch((error) => {
              if (error.response.data.errors.find((el: any) => el.param == 'pin')) setStatus('pinError');
              else setStatus('error');
            });
        }}
      />
    </>
  );
};
export default Page;
